import api from './axiosConfig.js'

export const faceApi = {
  startEnrollment: (employeeId) =>
    api.post('/face/enroll/enroll/start', { employee_id: employeeId }),

  saveEnrollment: (enrollmentData, orgId, config = {}) =>
    api.post('/face/enroll/save', enrollmentData, {
      ...config,
      headers: {
        ...(orgId ? { 'X-Org-ID': orgId } : {}),
        ...(config.headers || {})
      }
    }),

  getFaceId: (employeeId) => {
    const orgId = localStorage.getItem('org_id')
    return api.get(`/face/enroll/get-faceid`, {
      params: { employee_id: employeeId },
      headers: orgId ? { 'X-Org-ID': orgId } : {}
    })
  },

  removeEnrollment: (facialId, config = {}) => {
    const orgId = localStorage.getItem('org_id')
    return api.delete(`/face/enroll/remove-enrollment`, {
      ...config,
      data: { facial_id: facialId },
      headers: {
        ...(orgId ? { 'X-Org-ID': orgId } : {}),
        ...(config.headers || {})
      }
    })
  },

  startVerification: () =>
    api.post('/face/verify/start-verification'),

  punchAttendance: (punchData) =>
    api.post('/face/verify/punch', punchData),
}